import React from "react";

import Svg, { Path, Circle} from "components/Svg";

const Timer = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 112 114"
		fill="none"
	>
		<Circle cx="51.5" cy="51.5" r="47.5" stroke="white" stroke-width="8"/>
		<Path d="M51 51V20" stroke="white" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>
		<Path d="M51 51H70" stroke="white" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>
	</Svg>
);

export default Timer;



// WEBPACK FOOTER //
// ./src/components/svgs/Timer/index.js